export function repalceHtmlToText(str) {
  str = str.replace(/<\/?.+?>/g, "");
  str = str.replace(/&nbsp;/g, "");
  return str;
}
